import DdPpFunctionList from '@/components/DdPpFunctionList'
import DdPpNotification from '@/components/DdPpNotification'

import flowMixin from '@/mixins/flowMixins'
import Logger from '@/rahmen/logger'
import effects from '@/rahmen/utils/effects'

import { mapGetters } from 'vuex'

export default {
  name: 'DashBoard',
  mixins: [flowMixin],
  components: {
    DdPpFunctionList,
    DdPpNotification
  },
  data: () => ({
    userSettingRec: {}
  }),
  computed: {
    ...mapGetters({
      userId: 'users/userId',
      kengenGroupCd: 'users/kengenGroupCd'
    })
  },
  created () {
    effects.loadStart()
    this.$store.dispatch('system/setViewTitle', 'トップメニュー')
    console.log('DashBoard.Created', this.$router)
  },
  mounted () {
    this.logger = new Logger('token', 'name')
    this.logger.debug('DashBoard.mounted', { loginId: this.loginId, password: this.password })
    window.setTimeout(effects.loadComplete, 1000)
    this.initialize()
    this.settingButtonState()
  },
  methods: {
    initialize: function (e) {
      console.log('initialize')
      effects.loadStart()
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstjinin', 'mstmenkyosho', 'vwcmstsharyo', 'msyskubun'], version: 1 }).then(() => {
        effects.loadComplete()
      })
    },
    settingButtonState: function (e) {
      console.log('settingButtonState')
      if (this.kengenGroupCd === '01') {
        this.OshiraseUpdateButtonDisp = true
        this.SystemOshiraseUpdateButtonDisp = true
      }
    },
    onRoute: function (e) {
      this.$store.dispatch('system/clearMessage')
    },
    onClick: function () {
      effects.loadStart()
      window.setTimeout(effects.loadComplete, 3000)
    },
    // ------------------------------
    // 共通関数
    // ------------------------------
    isLatest: function (targetDate) {
      // １週間前の日付を取得
      var xDate = this.get1WeekAgoDay().replaceAll('/', '')

      // 日付比較
      var tDate = targetDate.substr(0, 10).replaceAll('-', '')
      if (xDate < tDate) {
        return true
      }
      return false
    },
    get1WeekAgoDay: function () {
      var date = new Date()
      date.setDate(date.getDate() - 7)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },
    getAfter30Day: function () {
      var date = new Date()
      date.setDate(date.getDate() + 30)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    }
  }
}
